// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"198":"540ed157","498":"5d5f2056","703":"054bd7ac","787":"f0649026"}[chunkId] + ".chunk.js";
};